export const RECOVERY_TOKEN = "RECOVERY_TOKEN";
export const RECOVERY_MESSAGES = "RECOVERY_MESSAGES";
export const RECOVERY_PASSWORD_UPDATE = "RECOVERY_PASSWORD_UPDATE";
export const RECOVERY_PASSWORD_VINCULADO_UPDATE =
  "RECOVERY_PASSWORD_VINCULADO_UPDATE";
export const RECOVERY_USUARIO_VINCULADO_SEND =
  "RECOVERY_USUARIO_VINCULADO_SEND";
